import { isNative, isAndroid } from "./capacitor";
import { syncWidgetSession } from "./widget-bridge";

/**
 * Initialise les plugins Capacitor natifs.
 * No-op sur le web — les imports dynamiques évitent de charger
 * les plugins inutilement dans le bundle web.
 */
export function initCapacitor(): void {
  if (!isNative) return;

  // Charger tous les plugins en parallèle
  Promise.all([
    import("@capacitor/app"),
    import("@capacitor/browser"),
    import("@capacitor/status-bar"),
  ]).then(([appMod, browserMod, statusBarMod]) => {
    // Status bar + nav bar — couleur adaptée au thème CSS
    const updateThemeColors = () => {
      const isDark = document.documentElement.classList.contains("dark");
      const color = isDark ? "#1a1a1a" : "#ffffff";

      if (statusBarMod) {
        statusBarMod.StatusBar.setStyle({ style: isDark ? statusBarMod.Style.Dark : statusBarMod.Style.Light });
        statusBarMod.StatusBar.setBackgroundColor({ color });
      }

      // Android : mettre à jour status bar + nav bar via le bridge natif
      if (isAndroid) {
        const bridge = (window as unknown as Record<string, unknown>).PalniaBridge as { setColors?: (c: string) => void } | undefined;
        bridge?.setColors?.(color);
      }
    };
    updateThemeColors();

    new MutationObserver(updateThemeColors).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    // Synchroniser la session vers le widget Android au démarrage + à chaque reprise
    if (isAndroid) {
      syncWidgetSession();
      appMod.App.addListener("resume", () => {
        syncWidgetSession();
      });
    }

    // Deep links (palnia://...) pour le callback OAuth + navigation widget
    appMod.App.addListener("appUrlOpen", ({ url }) => {
      const parsed = new URL(url);

      // OAuth callback
      const oauthCode = parsed.searchParams.get("oauth_code");
      if (oauthCode) {
        browserMod.Browser.close();
        const current = new URL(window.location.href);
        current.searchParams.set("oauth_code", oauthCode);
        window.location.replace(current.toString());
        return;
      }

      // Navigation depuis le widget (palnia://calendar, palnia://settings, etc.)
      const path = parsed.hostname || parsed.pathname.replace(/^\/+/, "");
      if (path) {
        const search = parsed.search || "";
        window.location.href = `/${path}${search}`;
      }
    });
  });
}
